import Vue from 'vue';
import Router from 'vue-router';

const login = r => require.ensure([], () => r(require('./views/login/mainNew.vue')), 'login'),
  layout = r => require.ensure([], () => r(require('./views/layout.vue')), 'layout'),
  home = r => require.ensure([], () => r(require('./views/home/main.vue')), 'home'),
  basicfile = r => require.ensure([], () => r(require('./views/basicfile/main.vue')), 'basicfile'),
  contract = r => require.ensure([], () => r(require('./views/contract/main.vue')), 'contract'),
  vehicle = r => require.ensure([], () => r(require('./views/vehiclelog/main.vue')), 'vehicle'),
  settle = r => require.ensure([], () => r(require('./views/settle/main.vue')), 'settle'),
  financial = r => require.ensure([], () => r(require('./views/financial/main.vue')), 'financial'),
  audit1 = r => require.ensure([], () => r(require('./views/audit/main.vue')), 'audit'),
  statistical = r => require.ensure([], () => r(require('./views/statistical/main.vue')), 'statistical'),
  system = r => require.ensure([], () => r(require('./views/system/main.vue')), 'system'),
  user = r => require.ensure([], () => r(require('./views/user/main.vue')), 'user'),
  download = r => require.ensure([], () => r(require('./views/downPage/main.vue')), 'download'),
  handheldDownload = r => require.ensure([], () => r(require('./views/downPage/handheldDownload.vue')), 'handheldDownload'),
  message = r => require.ensure([], () => r(require('./views/message/main.vue')), 'message'),
  branch = r => require.ensure([], () => r(require('./views/basicfile/system/branch.vue')), 'branch'),
  department = r => require.ensure([], () => r(require('./views/basicfile/system/department.vue')), 'department'),
  role = r => require.ensure([], () => r(require('./views/basicfile/system/role.vue')), 'role'),
  appRole = r => require.ensure([], () => r(require('./views/basicfile/system/appRole.vue')), 'appRole'),
  user1 = r => require.ensure([], () => r(require('./views/basicfile/system/user.vue')), 'user1'),
  operation = r => require.ensure([], () => r(require('./views/basicfile/system/operation.vue')), 'user1'),
  company = r => require.ensure([], () => r(require('./views/basicfile/customer/company.vue')), 'company'),
  companytype = r => require.ensure([], () => r(require('./views/basicfile/customer/type.vue')), 'companytype'),
  car1 = r => require.ensure([], () => r(require('./views/basicfile/customer/car.vue')), 'car1'),
  driver = r => require.ensure([], () => r(require('./views/basicfile/carriers/driver.vue')), 'driver'),
  ship = r => require.ensure([], () => r(require('./views/basicfile/carriers/ship.vue')), 'ship'),
  port = r => require.ensure([], () => r(require('./views/basicfile/carriers/port.vue')), 'port'),
  supplierManagement = r => require.ensure([], () => r(require('./views/basicfile/carriers/supplierManagement.vue')), 'supplierManagement'),
  warehouse1 = r => require.ensure([], () => r(require('./views/basicfile/warehouse/warehouse.vue')), 'warehouse'),
  floor = r => require.ensure([], () => r(require('./views/basicfile/warehouse/floor.vue')), 'floor'),
  location = r => require.ensure([], () => r(require('./views/basicfile/warehouse/location.vue')), 'location'),
  carModel = r => require.ensure([], () => r(require('./views/basicfile/customer/carModel/carModel.vue')), 'carModel'),
  consignorWarehouse = r => require.ensure([], () => r(require('./views/basicfile/customer/warehouse.vue')), 'consignorWarehouse'),
  distributor = r => require.ensure([], () => r(require('./views/basicfile/Distribution/distributor.vue')), 'distributor'),

  dictionariesAd = r => require.ensure([], () => r(require('./views/basicfile/dictionaries/dictionariesAd.vue')), 'dictionariesAd'),


  daily = r => require.ensure([], () => r(require('./views/contract/consignor/daily.vue')), 'daily'),
  monthly = r => require.ensure([], () => r(require('./views/contract/supplier/monthlyAssessment/index')), 'monthly'),
  trainRecord = r => require.ensure([], () => r(require('./views/contract/consignor/trainRecord.vue')), 'trainRecord'),
  consignment = r => require.ensure([], () => r(require('./views/settle/entrust/consignment.vue')), 'consignment'),
  portCharges = r => require.ensure([], () => r(require('./views/settle/entrust/portCharges.vue')), 'portCharges'),
  collection = r => require.ensure([], () => r(require('./views/settle/settlement/collection.vue')), 'collection'),
  payment = r => require.ensure([], () => r(require('./views/settle/settlement/payment.vue')), 'payment'),
  advance = r => require.ensure([], () => r(require('./views/settle/settlement/advance.vue')), 'advance'),
  paying = r => require.ensure([], () => r(require('./views/settle/bill/paying.vue')), 'paying'),
  elsePrice = r => require.ensure([], () => r(require('./views/settle/else/else.vue')), 'elsePrice'),
  recordAdjust = r => require.ensure([], () => r(require('./views/settle/recordAdjust/index.vue')), 'recordAdjust'),
  revenueSettlement = r => require.ensure([], () => r(require('./views/settle/reconciliation/revenueSettlement/index.vue')), 'revenueSettlement'),
  contractSettlement = r => require.ensure([], () => r(require('./views/settle/reconciliation/contractSettlement/index.vue')), 'contractSettlement'),
  tenderDocumentSettlement = r => require.ensure([], () => r(require('./views/settle/reconciliation/tenderDocumentSettlement/index.vue')), 'tenderDocumentSettlement'),
  discount = r => require.ensure([], () => r(require('./views/settle/else/discount.vue')), 'discount'),
  oilPrice = r => require.ensure([], () => r(require('./views/settle/else/oilPrice.vue')), 'oilPrice'),
  statement = r => require.ensure([], () => r(require('./views/settle/bill/statement.vue')), 'statement'),
  consignSettle = r => require.ensure([], () => r(require('./views/settle/supplier/consignSettle.vue')), 'consignSettle'),
  portSettle = r => require.ensure([], () => r(require('./views/settle/supplier/portSettle.vue')), 'portSettle'),
  fuelCost = r => require.ensure([], () => r(require('./views/settle/supplier/components/electrify.vue')), 'fuelCost'),
  storeroom = r => require.ensure([], () => r(require('./views/settle/supplier/storeroom.vue')), 'storeroom'),
  supplierElseStatements = r => require.ensure([], () => r(require('./views/settle/supplier/supplierElseStatements/index.vue')), 'supplierElseStatements'),
  supplierDeductionExpenses = r => require.ensure([], () => r(require('./views/settle/supplier/supplierDeductionExpenses/index.vue')), 'supplierDeductionExpenses'),
  supplierReconciliationAdjustmentStatement = r => require.ensure([], () => r(require('./views/settle/supplier/supplierReconciliationAdjustmentStatement/index.vue')), 'supplierElseStatements'),

  shippingCharges = r => require.ensure([], () => r(require('./views/settle/client/shippingCharges.vue')), 'shippingCharges'),
  // shippingCharges = r => require.ensure([], () => r(require('./views/settle/client/newShippingCharges.vue')), 'shippingCharges'),
  portCharges1 = r => require.ensure([], () => r(require('./views/settle/client/portCharges.vue')), 'portCharges1'),
  unknown1 = r => require.ensure([], () => r(require('./views/settle/client/unknown.vue')), 'unknown1'),
  shippingFee = r => require.ensure([], () => r(require('./views/settle/supplierStatement/shippingFee.vue')), 'shippingFee'),
  portFee = r => require.ensure([], () => r(require('./views/settle/supplierStatement/portFee.vue')), 'portFee'),
  warehouseFee = r => require.ensure([], () => r(require('./views/settle/supplierStatement/warehouseFee.vue')), 'warehouseFee'),
  unknown = r => require.ensure([], () => r(require('./views/settle/entrust/unknown.vue')), 'unknown'),
  exceedContract = r => require.ensure([], () => r(require('./views/settle/otherBills/exceedContract.vue')), 'exceedContract'),
  deferInvoicing = r => require.ensure([], () => r(require('./views/settle/otherBills/deferInvoicing.vue')), 'deferInvoicing'),

  accountDetails = r => require.ensure([], () => r(require('./views/settle/accountManagement/accountDetails/index.vue')), 'accountDetails'),
  financeAccount = r => require.ensure([], () => r(require('./views/settle/accountManagement/financeAccount/index.vue')), 'financeAccount'),
  ledgerSummary = r => require.ensure([], () => r(require('./views/settle/accountManagement/ledgerOrReconciliationSummary/index.vue')), 'ledgerSummary'),
  financeReconciliation = r => require.ensure([], () => r(require('./views/settle/accountManagement/financeReconciliation/index')), 'financeReconciliation'),
  reconciliationSummary = r => require.ensure([], () => r(require('./views/settle/accountManagement/ledgerOrReconciliationSummary/index')), 'reconciliationSummary'),


  steam = r => require.ensure([], () => r(require('./views/basicfile/carriers/team.vue')), 'steam'),
  truck = r => require.ensure([], () => r(require('./views/basicfile/carriers/truck.vue')), 'truck'),
  water = r => require.ensure([], () => r(require('./views/basicfile/carriers/water.vue')), 'water'),
  supplier = r => require.ensure([], () => r(require('./views/basicfile/carriers/supplier.vue')), 'supplier'),
  adress = r => require.ensure([], () => r(require('./views/basicfile/adress/adress.vue')), 'adress'),
  area = r => require.ensure([], () => r(require('./views/basicfile/adress/area.vue')), 'area'),
  harbor = r => require.ensure([], () => r(require('./views/basicfile/adress/harbor.vue')), 'harbor'),
  list = r => require.ensure([], () => r(require('./views/contract/management/list/list.vue')), 'list'),
  audit = r => require.ensure([], () => r(require('./views/audit/auditManagement/audit.vue')), 'audit'),
  type = r => require.ensure([], () => r(require('./views/contract/management/type.vue')), 'type'),
  priceReview = r => require.ensure([], () => r(require('./views/contract/management/priceReview.vue')), 'priceReview'),
  year = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/year.vue')), 'year'),
  yearMonthPlan = r => require.ensure([], () => r(require('./views/vehiclelog/yearMonthPlan/YearMonthPlan.vue')), 'yearMonthPlan'),
  forecastPlan = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/forecastPlan.vue')), 'forecastPlan'),
  transportPlan = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/transportPlan.vue')), 'transportPlan'),
  importPlan = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/importPlan.vue')), 'importPlan'),
  completePlan = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/completePlan.vue')), 'completePlan'),
  carmanage = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/car.vue')), 'carmanage'),
  driverManage = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/driver.vue')), 'driverManage'),
  highwayStat = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/highwayStat.vue')), 'highwayStat'),
  waterStat = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/waterStat.vue')), 'waterStat'),
  shipmanage = r => require.ensure([], () => r(require('./views/vehiclelog/planManage/ship.vue')), 'shipmanage'),
  task = r => require.ensure([], () => r(require('./views/vehiclelog/highway/taskManage.vue')), 'task'),
  sweepyard = r => require.ensure([], () => r(require('./views/vehiclelog/highway/sweepYard.vue')), 'sweepyard'),
  board = r => require.ensure([], () => r(require('./views/vehiclelog/highway/board.vue')), 'board'),
  management = r => require.ensure([], () => r(require('./views/vehiclelog/highway/manage.vue')), 'management'),
  cost = r => require.ensure([], () => r(require('./views/vehiclelog/highway/cost.vue')), 'cost'),
  voyage = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/voyage.vue')), 'voyage'),
  shipment = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/shipment.vue')), 'shipment'),
  discharging = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/discharging.vue')), 'discharging'),
  overside = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/overside.vue')), 'overside'),
  transshipment = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/transshipment.vue')), 'transshipment'),
  lock = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/lock.vue')), 'lock'),
  specialships = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/specialShips.vue')), 'specialships'),
  scanning = r => require.ensure([], () => r(require('./views/vehiclelog/waterway/scanning.vue')), 'scanning'),
  inbound = r => require.ensure([], () => r(require('./views/vehiclelog/warehouse/inbound.vue')), 'inbound'),
  outbound = r => require.ensure([], () => r(require('./views/vehiclelog/warehouse/outbound.vue')), 'outbound'),
  dispatch = r => require.ensure([], () => r(require('./views/vehiclelog/warehouse/dispatch.vue')), 'dispatch'),

  portTracking = r => require.ensure([], () => r(require('./views/vehiclelog/transitInf/portTracking.vue')), 'portTracking'),

  carTracking = r => require.ensure([], () => r(require('./views/vehiclelog/transitInf/carTracking.vue')), 'carTracking'),
  teamTracking = r => require.ensure([], () => r(require('./views/vehiclelog/transitInf/teamTracking.vue')), 'teamTracking'),
  shipTracking = r => require.ensure([], () => r(require('./views/vehiclelog/transitInf/shipTracking.vue')), 'shipTracking'),
  shipTracking2 = r => require.ensure([], () => r(require('./views/vehiclelog/shipTracking/index.vue')), 'shipTracking2'),
  report = r => require.ensure([], () => r(require('./views/vehiclelog/massLoss/report.vue')), 'report'),
  list2 = r => require.ensure([], () => r(require('./views/vehiclelog/massLoss/list.vue')), 'list2'),
  qualityLossList = r => require.ensure([], () => r(require('./views/vehiclelog/qualityLossList/index')), 'qualityLossList'),
  audit2 = r => require.ensure([], () => r(require('./views/vehiclelog/massLoss/audit.vue')), 'audit2'),
  lineSet = r => require.ensure([], () => r(require('./views/vehiclelog/logisticsConfig/lineSetCopy.vue')), 'lineSet'),
  entrustprice = r => require.ensure([], () => r(require('./views/financial/price/entrust.vue')), 'entrustprice'),
  stockpiledPrice = r => require.ensure([], () => r(require('./views/financial/price/stockpiledPrice.vue')), 'stockpiledPrice'),
  port2 = r => require.ensure([], () => r(require('./views/financial/price/port.vue')), 'port2'),
  warehouse2 = r => require.ensure([], () => r(require('./views/financial/price/warehouse.vue')), 'warehouse'),
  mention = r => require.ensure([], () => r(require('./views/financial/price/mention.vue')), 'mention'),
  highway = r => require.ensure([], () => r(require('./views/financial/price/highway/highway.vue')), 'highway'),
  other = r => require.ensure([], () => r(require('./views/financial/price/other.vue')), 'other'),
  labor = r => require.ensure([], () => r(require('./views/financial/price/labor.vue')), 'labor'),
  porta = r => require.ensure([], () => r(require('./views/financial/price/porta.vue')), 'porta'),
  waterway = r => require.ensure([], () => r(require('./views/financial/price/incomeLinePrice/waterway.vue')), 'waterway'),
  portWork = r => require.ensure([], () => r(require('./views/financial/price/incomeLinePrice/portWork.vue')), 'portWork'),

  // const port1 = r => require.ensure([], () => r(require('./views/financial/settlement/port1.vue')), 'port1');

  car = r => require.ensure([], () => r(require('./views/financial/settlement/car.vue')), 'car'),
  ship2 = r => require.ensure([], () => r(require('./views/financial/settlement/ship.vue')), 'ship2'),
  handling = r => require.ensure([], () => r(require('./views/financial/settlement/handling.vue')), 'handling'),
  car2 = r => require.ensure([], () => r(require('./views/financial/payment/car.vue')), 'car2'),
  financialConfirmation = r => require.ensure([], () => r(require('./views/financial/payment/financialConfirmation.vue')), 'financialConfirmation'),
  ship3 = r => require.ensure([], () => r(require('./views/financial/payment/ship.vue')), 'ship3'),
  income2 = r => require.ensure([], () => r(require('./views/financial/financ/income.vue')), 'income2'),
  expend = r => require.ensure([], () => r(require('./views/financial/financ/expend.vue')), 'expend'),
  handling2 = r => require.ensure([], () => r(require('./views/financial/payment/handling.vue')), 'handling2'),
  consignorSpecialPrice = r => require.ensure([], () => r(require('./views/financial/consignorSpecialPrice/index.vue')), 'consignorSpecialPrice'),
  supplierSpecialPrice = r => require.ensure([], () => r(require('./views/financial/supplierSpecialPrice/index.vue')), 'supplierSpecialPrice'),
  monthlyMonthlyPlannedExpenditurePriceSetting = r => require.ensure([], () => r(require('./views/financial/monthlyMonthlyPlannedExpenditurePriceSetting/MonthlyMonthlyPlannedExpenditurePriceSetting.vue')), 'monthlyMonthlyPlannedExpenditurePriceSetting'),
  commercialCarPrice = r => require.ensure([], () => r(require('./views/financial/commercialCarPrice/index')), 'commercialCarPrice'),
  reconciliationDetails = r => require.ensure([], () => r(require('./views/financial/reconciliationDetails/index')), 'reconciliationDetails'),
  mothFreightVolumeReport = r => require.ensure([], () => r(require('./views/financial/mothFreightVolumeReport/index')), 'mothFreightVolumeReport'),
  riverTransportationReport = r => require.ensure([], () => r(require('./views/financial/riverTransportationReport/index')), 'riverTransportationReport'),
  commercialCarPlan = r => require.ensure([], () => r(require('./views/financial/commercialCarPlan/index.vue')), 'commercialCarPlan'),
  yearAndMonthReport = r => require.ensure([], () => r(require('./views/financial/yearAndMonthReport/index.vue')), 'yearAndMonthReport'),
  yearAndMonthSummary = r => require.ensure([], () => r(require('./views/financial/yearAndMonthSummary/index.vue')), 'yearAndMonthSummary'),
  monthlyPlan = r => require.ensure([], () => r(require('./views/financial/dataDifferenceAnalysis/monthlyPlan/index.vue')), 'monthlyPlan'),
  provisionalIncomeExpenditure = r => require.ensure([], () => r(require('./views/financial/dataDifferenceAnalysis/provisionalIncomeExpenditure/index.vue')), 'provisionalIncomeExpenditure'),
  preSettlementIncomeExpenditure = r => require.ensure([], () => r(require('./views/financial/dataDifferenceAnalysis/preSettlementIncomeExpenditure/index.vue')), 'preSettlementIncomeExpenditure'),
  warehouseAndOther = r => require.ensure([], () => r(require('./views/financial/dataDifferenceAnalysis/warehouseAndOther/index.vue')), 'warehouseAndOther'),
  revenueAndExpenditureAndNetValue = r => require.ensure([], () => r(require('./views/financial/revenueAndExpenditureAndNetValue/index.vue')), 'revenueAndExpenditureAndNetValue'),


  day = r => require.ensure([], () => r(require('./views/audit/auditManagement/day.vue')), 'day'),
  entrust = r => require.ensure([], () => r(require('./views/audit/auditManagement/entrust.vue')), 'entrust'),
  transportCar = r => require.ensure([], () => r(require('./views/audit/auditManagement/transportCar.vue')), 'transportCar'),
  highWay = r => require.ensure([], () => r(require('./views/audit/auditManagement/highWay.vue')), 'highWay'),
  month = r => require.ensure([], () => r(require('./views/audit/auditManagement/month.vue')), 'month'),
  pay = r => require.ensure([], () => r(require('./views/audit/auditManagement/pay.vue')), 'pay'),
  price = r => require.ensure([], () => r(require('./views/audit/auditManagement/price.vue')), 'price'),
  settle1 = r => require.ensure([], () => r(require('./views/audit/auditManagement/settle.vue')), 'settle'),
  person = r => require.ensure([], () => r(require('./views/audit/personManagement/person.vue')), 'person'),
  // monthlyPerson = r => require.ensure([], () => r(require('./views/audit/personManagement/monthlyPerson.vue')), 'monthlyPerson'),
  supplierTrain = r => require.ensure([], () => r(require('./views/audit/auditManagement/supplierTrain.vue')), 'supplierTrain'),
  otherFees = r => require.ensure([], () => r(require('./views/audit/auditManagement/otherFees.vue')), 'otherFees'),
  deductCost = r => require.ensure([], () => r(require('./views/audit/auditManagement/deduct.vue')), 'deductCost'),
  accountStatement = r => require.ensure([], () => r(require('./views/audit/auditManagement/accountStatement.vue')), 'accountStatement'),
  statementReview = r => require.ensure([], () => r(require('./views/audit/auditManagement/statementReview.vue')), 'statementReview'),
  dataModification = r => require.ensure([], () => r(require('./views/audit/auditManagement/dataModification.vue')), 'dataModification'),
  change = r => require.ensure([], () => r(require('./views/audit/auditManagement/change.vue')), 'change'),
  // monthlyPlanReview = r => require.ensure([], () => r(require('./views/audit/vehicleAudit/monthlyPlanReview/index.vue')), 'monthlyPlanReview'),


  income = r => require.ensure([], () => r(require('./views/statistical/financialStatements/income.vue')), 'income'),
  expense = r => require.ensure([], () => r(require('./views/statistical/financialStatements/expense.vue')), 'expense'),
  order = r => require.ensure([], () => r(require('./views/statistical/businessReport/order.vue')), 'order'),
  car3 = r => require.ensure([], () => r(require('./views/statistical/businessReport/car.vue')), 'car3'),
  ship4 = r => require.ensure([], () => r(require('./views/statistical/businessReport/ship.vue')), 'ship4'),
  warehouse = r => require.ensure([], () => r(require('./views/statistical/businessReport/warehouse.vue')), 'warehouse'),
  operating = r => require.ensure([], () => r(require('./views/statistical/operating/operating.vue')), 'operating'),
  storageRoom = r => require.ensure([], () => r(require('./views/warehouseManagement/storageRoom/index.vue')), 'storageRoom'),
  Devops = r => require.ensure([], () => r(require('./views/DevOps/index.vue')), 'Devops'),
  Cache = r => require.ensure([], () => r(require('./views/DevOps/cache-data/cacheData')), 'Cache'),
  transmissionManagement = r => require.ensure([], () => r(require('./views/DevOps/transmissionManagement/index.vue')), 'transmissionManagement'),
  electronicFence = r => require.ensure([], () => r(require('./views/DevOps/electronicFence/index.vue')), 'electronicFence'),
  statisticalAnalysisOfBrandTraffic = r => require.ensure([], () => r(require('./views/vehiclelog/statisticalAnalysisReport/statisticalAnalysisOfBrandTraffic/index')), 'statisticalAnalysisOfBrandTraffic'),
  shippingStatistics = r => require.ensure([], () => r(require('./views/vehiclelog/statisticalAnalysisReport/shippingStatistics/index.vue')), 'shippingStatistics'),
  operateRecordReport = r => require.ensure([], () => r(require('./views/vehiclelog/statisticalAnalysisReport/operateRecordReport/index.vue')), 'operateRecordReport'),
  portInformation = r => require.ensure([], () => r(require('./views/vehiclelog/statisticalAnalysisReport/portInformation/index.vue')), 'portInformation'),
  pickupTruckInformation = r => require.ensure([], () => r(require('./views/vehiclelog/statisticalAnalysisReport/pickupTruckInformation/index.vue')), 'pickupTruckInformation'),
  changeManagement = r => require.ensure([], () => r(require('./views/vehiclelog/changeManagement/index.vue')), 'changeManagement'),


  // 库房 START
  consignorWarehouseNew = r => require.ensure([], () => r(require('./views/basicfile/warehouseManagement/index.vue')), 'consignorWarehouseNew'),
  portWarehouseCharges = r => require.ensure([], () => r(require('./views/warehouseManagement/port-warehouse-charges/index.vue')), 'portWarehouseCharges'),
  harborWarehouseIncomePriceSetting = r => require.ensure([], () => r(require('./views/financial/price/harbor-warehouse-income-price-setting/index.vue')), 'harborWarehouseIncomePriceSetting'),
  monthYearPlanRevenuePriceSetting = r => require.ensure([], () => r(require('./views/financial/price/monthYearPlanRevenuePriceSetting/MonthYearPlanRevenuePriceSetting.vue')), 'monthYearPlanRevenuePriceSetting'),
  portWarehouseExpenditurePriceSetting = r => require.ensure([], () => r(require('./views/financial/price/port-warehouse-expenditure-price-setting/index.vue')), 'portWarehouseExpenditurePriceSetting'),
  clientPortWarehouseSettlement = r => require.ensure([], () => r(require('./views/settle/client-port-warehouse-settlement/index')), 'clientPortWarehouseSettlement'),
  supplierPortWarehouseSettlement = r => require.ensure([], () => r(require('./views/settle/supplier/supplier-port-warehouse-settlement/index.vue')), 'supplierPortWarehouseSettlement'),
  portWarehouseLedger = r => require.ensure([], () => r(require('./views/settle/accountManagement/portWarehouseLedger/index.vue')), 'portWarehouseLedger'),
  clientWarehouseStatement = r => require.ensure([], () => r(require('./views/settle/client/clientWarehouseStatement/index.vue')), 'clientWarehouseStatement'),
  clientElseStatements = r => require.ensure([], () => r(require('./views/settle/client/clientElseStatements/index.vue')), 'clientElseStatements'),
  clientDeductionExpenses = r => require.ensure([], () => r(require('./views/settle/client/clientDeductionExpenses/index.vue')), 'clientDeductionExpenses'),
  reconciliationAdjustmentStatement = r => require.ensure([], () => r(require('./views/settle/client/reconciliationAdjustmentStatement/index.vue')), 'reconciliationAdjustmentStatement'),

  supplierWarehouseStatement = r => require.ensure([], () => r(require('./views/settle/supplier/supplier-warehouse-statement/index.vue')), 'supplierWarehouseStatement'),
  // 库房 END

  // 回单 START
  supplierDelivery = r => require.ensure([], () => r(require('./views/settle/deliveryManagement/supplierDelivery/index.vue')), 'supplierDelivery'),
  settlementDelivery = r => require.ensure([], () => r(require('./views/settle/deliveryManagement/settlementDelivery/index.vue')), 'settlementDelivery'),
  deliveryReport = r => require.ensure([], () => r(require('./views/settle/deliveryManagement/deliveryReport/index')), 'deliveryReport'),
  // 回单 END
  //结算统计分析报表 START
  settlementProgress = r => require.ensure([], () => r(require('./views/settle/settlementAnalysisStatement/settlementProgress.vue')), 'settlementProgress'),
  IncomeStatistics = r => require.ensure([], () => r(require('./views/settle/settlementAnalysisStatement/IncomeStatistics.vue')), 'IncomeStatistics'),
  revenueSegmentation = r => require.ensure([], () => r(require('./views/settle/settlementAnalysisStatement/revenueSegmentation.vue')), 'revenueSegmentation'),
  //结算统计分析报表 END

  // 收款/付款
  statistics = r => require.ensure([], () => r(require('./views/financial/report/statistics/index.vue')), 'statistics'),

  // 供应商月考核指标设置
  monthlyAssessmentIndexSetting = r => require.ensure([], () => r(require('./views/contract/supplier/monthlyAssessmentIndexSetting/index')), 'monthlyAssessmentIndexSetting'),

  // 财务审核-整车结算
  vehicleSettlement = r => require.ensure([], () => r(require('./views/audit/financialAudit/vehicleSettlement/index')), 'vehicleSettlement'),

  // 财务审核-金融监管
  // financialSupervision = r => require.ensure([], () => r(require('./views/audit/financialAudit/financialSupervision/index')), 'financialSupervision'),

  // 水路运输管理-船舶运行动态表
  shipRunningDynamicTable = r => require.ensure([], () => r(require('./views/vehiclelog/shipRunningDynamicTable/index')), 'shipRunningDynamicTable');

Vue.use(Router);

export default new Router({
  'routes': [
    {
      'path': '/',
      'redirect': '/login'
    },
    // 登录
    {
      'path': '/login',
      'name': 'login',
      'component': login
    },
    // 下载页面
    {
      'path': '/download',
      'name': 'download',
      'component': download
    },
    // 手持机微信提示使用路由器下载页面
    {
      'path': '/handheldDownload',
      'name': 'handheldDownload',
      'component': handheldDownload
    },
    {
      'path': '/layout',
      'name': 'layout',
      'component': layout,
      'children': [
        // 首页
        {
          'path': '/home',
          'name': 'home',
          'component': home
        },
        // 基础档案
        {
          'path': '/basicfile',
          'name': 'basicfile',
          'component': basicfile,
          'children': [
            // 分公司管理
            {
              'path': '/basicfile/branch',
              'name': 'branchManage',
              'component': branch
            },
            // 部门管理
            {
              'path': '/basicfile/department',
              'name': 'department',
              'component': department
            },
            // PC角色管理
            {
              'path': '/basicfile/role',
              'name': 'role',
              'component': role
            },
            // app角色管理
            {
              'path': '/basicfile/appRole',
              'name': 'appRole',
              'component': appRole
            },
            // 用户管理
            {
              'path': '/basicfile/user',
              'name': 'user1',
              'component': user1
            },
            // 运营调度
            {
              'path': '/basicfile/operation',
              'name': 'operation',
              'component': operation
            },
            // 委托商管理
            {
              'path': '/basicfile/company',
              'name': 'company',
              'component': company
            },
            // 委托商类型
            {
              'path': '/basicfile/type',
              'name': 'companytype',
              'component': companytype
            },
            // 委托车信息
            {
              'path': '/basicfile/car',
              'name': 'car1',
              'component': car1
            },
            // 委托车车型
            {
              'path': '/basicfile/carModel',
              'name': 'carModel',
              'component': carModel
            },
            // 委托商仓库管理
            {
              'path': '/basicfile/consignorWarehouse',
              'name': 'consignorWarehouse',
              'component': consignorWarehouse,
              'meta': {
                'title': '委托商仓库管理'
              }
            },
            // 车队管理
            {
              'path': '/basicfile/team',
              'name': 'steam',
              'component': steam
            },
            // 司机管理
            {
              'path': '/basicfile/driver',
              'name': 'driver',
              'component': driver
            },
            // 运输车管理
            {
              'path': '/basicfile/truck',
              'name': 'truck',
              'component': truck
            },
            // 经销商管理
            {
              'path': '/basicfile/distributor',
              'name': 'distributor',
              'component': distributor
            },
            // 水路供应商
            {
              'path': '/basicfile/water',
              'name': 'water',
              'component': water
            },
            // 供应商管理
            {
              'path': '/basicfile/supplier',
              'name': 'supplier',
              'component': supplier
            },
            // 船舶管理
            {
              'path': '/basicfile/ship',
              'name': 'ship',
              'component': ship
            },
            // 港口及其它
            {
              'path': '/basicfile/port',
              'name': 'port',
              'component': port
            },
            // 供应商管理
            {
              'path': '/basicfile/supplierManagement',
              'name': 'supplierManagement',
              'component': supplierManagement
            },
            // 仓库管理
            {
              'path': '/basicfile/warehouse',
              'name': 'warehouse',
              'component': warehouse1
            },
            // 楼层管理
            {
              'path': '/basicfile/floor',
              'name': 'floor',
              'component': floor
            },
            // 库位管理
            {
              'path': '/basicfile/location',
              'name': 'location',
              'component': location
            },
            // 地址管理
            {
              'path': '/basicfile/adress',
              'name': 'adress',
              'component': adress
            },
            // 区域管理
            {
              'path': '/basicfile/area',
              'name': 'area',
              'component': area
            },
            // 港口管理
            {
              'path': '/basicfile/harbor',
              'name': 'harbor',
              'component': harbor
            },
            // 库房管理
            {
              'path': '/basicfile/consignorWarehouseNew',
              'name': 'consignorWarehouseNew',
              'component': consignorWarehouseNew
            },
            // 字典管理
            {
              'path': '/basicfile/dictionariesAd',
              'name': 'dictionariesAd',
              'component': dictionariesAd,
              'meta': {
                'title': '字典管理'
              }
            }
          ]
        },
        // 合同管理
        {
          'path': '/contract',
          'name': 'contract',
          'component': contract,
          'children': [
            // 合同列表
            {
              'path': '/contract/list',
              'name': 'list',
              'component': list
            },

            // 地址管理
            {
              'path': '/contract/type',
              'name': 'type',
              'component': type
            },
            // 价格评审
            {
              'path': '/contract/priceReview',
              'name': 'priceReview',
              'component': priceReview
            },
            // 日常考核
            {
              'path': '/contract/daily',
              'name': 'daily',
              'component': daily
            },
            // 月考核
            {
              'path': '/contract/monthly',
              'name': 'monthly',
              'component': monthly
            },
            // 供应商月考核指标设置
            {
              'path': '/contract/monthlyAssessmentIndexSetting',
              'name': 'monthlyAssessmentIndexSetting',
              'component': monthlyAssessmentIndexSetting
            },
            // 培训记录
            {
              'path': '/contract/trainRecord',
              'name': 'trainRecord',
              'component': trainRecord
            }
          ]
        },
        // 整车物流
        {
          'path': '/vehicle',
          'name': 'vehicle',
          'component': vehicle,
          'children': [
            // 计划管理-商品车计划
            {
              'path': '/vehicle/commercialCarPlan',
              'name': 'commercialCarPlan',
              'component': commercialCarPlan
            },
            // 年运输计划管理 yearMonthPlan
            {
              'path': '/vehicle/year',
              'name': 'year',
              'component': year
            },
            // 年月计划
            {
              'path': '/vehicle/yearMonthPlan',
              'name': 'yearMonthPlan',
              'component': yearMonthPlan
            },
            // 预报计划
            {
              'path': '/vehicle/forecast',
              'name': 'forecast',
              'component': forecastPlan
            },
            // 运输计划
            {
              'path': '/vehicle/transport',
              'name': 'transport',
              'component': transportPlan
            },
            // 接口运输计划
            {
              'path': '/vehicle/importPlan',
              'name': 'importPlan',
              'component': importPlan
            },
            // 完善运输计划
            {
              'path': '/vehicle/completePlan',
              'name': 'completePlan',
              'component': completePlan
            },
            // 车辆调配管理
            {
              'path': '/vehicle/carmanage',
              'name': 'carmanage',
              'component': carmanage
            },
            // 司机装车管理
            {
              'path': '/vehicle/driverManage',
              'name': 'driverManage',
              'component': driverManage
            },
            // 公路在途委托车统计
            {
              'path': '/vehicle/highwayStat',
              'name': 'highwayStat',
              'component': highwayStat
            },
            // 船舶调配管理
            {
              'path': '/vehicle/shipmanage',
              'name': 'shipmanage',
              'component': shipmanage
            },
            // 水路在途委托车统计
            {
              'path': '/vehicle/waterStat',
              'name': 'waterStat',
              'component': waterStat
            },
            // 任务管理(公路)
            {
              'path': '/vehicle/task',
              'name': 'task',
              'component': task
            },
            // 扫码装车
            {
              'path': '/vehicle/sweepyard',
              'name': 'sweepyard',
              'component': sweepyard
            },
            // 换版管理
            {
              'path': '/vehicle/board',
              'name': 'board',
              'component': board
            },
            // 换版管理
            {
              'path': '/vehicle/board',
              'name': 'board',
              'component': board
            },
            // 交车管理
            {
              'path': '/vehicle/management',
              'name': 'management',
              'component': management
            },
            // 费用报销
            {
              'path': '/vehicle/cost',
              'name': 'cost',
              'component': cost
            },
            // 航次管理
            {
              'path': '/vehicle/voyage',
              'name': 'voyage',
              'component': voyage
            },
            // 任务管理(水路) 港口调配
            {
              'path': '/vehicle/shipment',
              'name': 'shipment',
              'component': shipment
            },
            // 卸船任务管理
            {
              'path': '/vehicle/discharging',
              'name': 'discharging',
              'component': discharging
            },
            // 过驳管理
            {
              'path': '/vehicle/overside',
              'name': 'overside',
              'component': overside
            },
            // 转船管理
            {
              'path': '/vehicle/transshipment',
              'name': 'transshipment',
              'component': transshipment
            },
            // 过闸管理
            {
              'path': '/vehicle/lock',
              'name': 'lock',
              'component': lock
            },
            // 特殊停船管理
            {
              'path': '/vehicle/specialships',
              'name': 'specialships',
              'component': specialships
            },
            // 船舶运行动态表
            {
              'path': '/vehicle/shipRunningDynamicTable',
              'name': 'shipRunningDynamicTable',
              'component': shipRunningDynamicTable
            },
            // 装卸扫描管理
            {
              'path': '/vehicle/scanning',
              'name': 'scanning',
              'component': scanning
            },
            // 入库管理
            {
              'path': '/vehicle/inbound',
              'name': 'inbound',
              'component': inbound
            },
            // 出库管理
            {
              'path': '/vehicle/outbound',
              'name': 'outbound',
              'component': outbound
            },
            // 出库调配车辆
            {
              'path': '/vehicle/dispatch',
              'name': 'dispatch',
              'component': dispatch
            },
            // 集港管理
            {
              'path': '/vehicle/port',
              'name': 'port1',
              'component': portTracking
            },
            // 托运车跟踪
            {
              'path': '/vehicle/car',
              'name': 'car',
              'component': carTracking
            },
            // 车队跟踪
            {
              'path': '/vehicle/team',
              'name': 'team',
              'component': teamTracking
            },
            // 水路跟踪
            {
              'path': '/vehicle/ship',
              'name': 'ship',
              'component': shipTracking
            },
            // 船舶跟踪
            {
              'path': '/vehicle/shipTracking',
              'name': 'shipTracking',
              'component': shipTracking2
            },
            // 质损上报
            {
              'path': '/vehicle/report',
              'name': 'report',
              'component': report
            },
            // 质损列表
            {
              'path': '/vehicle/list',
              'name': 'list2',
              'component': list2
            },
            // 质损列表
            {
              'path': '/vehicle/qualityLossList',
              'name': 'qualityLossList',
              'component': qualityLossList
            },
            // 质损审核
            {
              'path': '/vehicle/audit',
              'name': 'audit2',
              'component': audit2
            },
            // 品牌运量统计分析
            {
              'path': '/vehicle/statisticalAnalysisOfBrandTraffic',
              'name': 'statisticalAnalysisOfBrandTraffic',
              'component': statisticalAnalysisOfBrandTraffic
            },
            // 发运统计报表
            {
              'path': '/vehicle/shippingStatistics',
              'name': 'shippingStatistics',
              'component': shippingStatistics
            },
            // 集港信息统计
            {
              'path': '/vehicle/portInformation',
              'name': 'portInformation',
              'component': portInformation
            },
            //操作记录统计报表
            {
              'path': '/vehicle/operateRecordReport',
              'name': 'operateRecordReport',
              'component': operateRecordReport
            },
            //零星车统计报表
            {
              'path': '/vehicle/pickupTruckInformation',
              'name': 'pickupTruckInformation',
              'component': pickupTruckInformation
            },
            // 线路设置
            {
              'path': '/vehicle/line',
              'name': 'lineSet',
              'component': lineSet
            },
            // 库房管理
            {
              'path': '/vehicle/storageRoom',
              'name': 'storageRoom',
              'component': storageRoom
            },
            // 港口库房费用
            {
              'path': '/vehicle/portWarehouseCharges',
              'name': 'portWarehouseCharges',
              'component': portWarehouseCharges
            },
            // 运维管理
            {
              'path': '/vehicle/Devops',
              'name': 'Devops',
              'component': Devops
            },
            {
              'path': '/vehicle/Cache',
              'name': 'Cache',
              'component': Cache
            },
            // 运输管理
            {
              'path': '/vehicle/transmissionManagement',
              'name': 'transmissionManagement',
              'component': transmissionManagement
            },
            // 运维管理
            {
              'path': '/vehicle/electronicFence',
              'name': 'electronicFence',
              'component': electronicFence
            },
            // 变更管理
            {
              'path': '/vehicle/changeManagement',
              'name': 'changeManagement',
              'component': changeManagement
            }
          ]
        },


        // 结算管理
        {
          'path': '/settle',
          'name': 'settle',
          'component': settle,
          'children': [
            //  托运费用结算
            {
              'path': '/settle/consignment',
              'name': 'consignment',
              'component': consignment
            },
            //  港口费用结算
            {
              'path': '/settle/portCharges',
              'name': 'portCharges',
              'component': portCharges
            },
            //  港口库房结算
            {
              'path': '/settle/clientPortWarehouseSettlement',
              'name': 'clientPortWarehouseSettlement',
              'component': clientPortWarehouseSettlement
            },
            //  收款结算
            {
              'path': '/settle/collection',
              'name': 'collection',
              'component': collection
            },
            //  付款结算
            {
              'path': '/settle/payment',
              'name': 'payment',
              'component': payment
            },
            //  收款预结算价结算
            {
              'path': '/settle/advance',
              'name': 'advance',
              'component': advance
            },
            //  收款对账单
            {
              'path': '/settle/statement',
              'name': 'statement',
              'component': statement
            },
            //  付款对账单
            {
              'path': '/settle/paying',
              'name': 'paying',
              'component': paying
            },
            //  抵扣开票费用
            {
              'path': '/settle/discount',
              'name': 'discount',
              'component': discount
            },
            //  其它费用
            {
              'path': '/settle/else',
              'name': 'elsePrice',
              'component': elsePrice
            },
            //  对账调整
            {
              'path': '/settle/recordAdjust',
              'name': 'recordAdjust',
              'component': recordAdjust
            },
            //  油价费用
            {
              'path': '/settle/oilPrice',
              'name': 'oilPrice',
              'component': oilPrice
            },
            // 供应商结算管理
            // 托运费用结算
            {
              'path': '/settle/supplier/consignSettle',
              'name': 'consignSettle',
              'component': consignSettle,
              'meta': {
                'title': '托运费用结算'
              }
            },
            {
              'path': '/settle/supplier/portSettle',
              'name': 'portSettle',
              'component': portSettle,
              'meta': {
                'title': '港口费用结算'
              }
            },
            {
              'path': '/settle/supplier/storeroom',
              'name': 'storeroom',
              'component': storeroom,
              'meta': {
                'title': '提车费结算'
              }
            },
            {
              'path': '/settle/supplierPortWarehouseSettlement',
              'name': 'supplierPortWarehouseSettlement',
              'component': supplierPortWarehouseSettlement
            },
            {
              'path': '/settle/unknown',
              'name': 'unknown',
              'component': unknown,
              'meta': {
                'title': '未知费用结算'
              }
            },
            {
              'path': '/settle/exceedContract',
              'name': 'exceedContract',
              'component': exceedContract,
              'meta': {
                'title': '补结算管理'
              }
            },
            {
              'path': '/settle/deferInvoicing',
              'name': 'deferInvoicing',
              'component': deferInvoicing,
              'meta': {
                'title': '暂缓开票对账单'
              }
            },
            // 托运费用对账单
            {
              'path': '/settle/shippingCharges',
              'name': 'shippingCharges',
              'component': shippingCharges
            },
            // 港口库房对账单（委托商）
            {
              'path': '/settle/clientWarehouseStatement',
              'name': 'clientWarehouseStatement',
              'component': clientWarehouseStatement
            },
            // 其他费用对账单（委托商）
            {
              'path': '/settle/clientElseStatements',
              'name': 'clientElseStatements',
              'component': clientElseStatements
            },
            // 抵扣费用对账单（委托商）
            {
              'path': '/settle/clientDeductionExpenses',
              'name': 'clientDeductionExpenses',
              'component': clientDeductionExpenses
            },
            // 对账调整对账单
            {
              'path': '/settle/reconciliationAdjustmentStatement',
              'name': 'reconciliationAdjustmentStatement',
              'component': reconciliationAdjustmentStatement
            },
            // 港口费用对账单
            {
              'path': '/settle/portCharges1',
              'name': 'portCharges1',
              'component': portCharges1
            },
            // 未知费用对账单
            {
              'path': '/settle/unknown1',
              'name': 'unknown1',
              'component': unknown1
            },
            // 托运费对账单
            {
              'path': '/settle/shippingFee',
              'name': 'shippingFee',
              'component': shippingFee
            },
            // 港口费对账单
            {
              'path': '/settle/portFee',
              'name': 'portFee',
              'component': portFee
            },
            // 提车费对账单
            {
              'path': '/settle/warehouseFee',
              'name': 'warehouseFee',
              'component': warehouseFee
            },
            // 港口库房对账单（供应商）
            {
              'path': '/settle/supplierWarehouseStatement',
              'name': 'supplierWarehouseStatement',
              'component': supplierWarehouseStatement
            },
            // 其他费用对账单（供应商）
            {
              'path': '/settle/supplierElseStatements',
              'name': 'supplierElseStatements',
              'component': supplierElseStatements
            },
            // 抵扣费用对账单（供应商）
            {
              'path': '/settle/supplierDeductionExpenses',
              'name': 'supplierDeductionExpenses',
              'component': supplierDeductionExpenses
            },
            // 对账调整对账单（供应商）
            {
              'path': '/settle/supplierReconciliationAdjustmentStatement',
              'name': 'supplierReconciliationAdjustmentStatement',
              'component': supplierReconciliationAdjustmentStatement
            },
            // 台账明细
            {
              'path': '/settle/accountDetails',
              'name': 'accountDetails',
              'component': accountDetails
            },
            // 港口库房台账
            {
              'path': '/settle/portWarehouseLedger',
              'name': 'portWarehouseLedger',
              'component': portWarehouseLedger
            },
            // 财务台账
            {
              'path': '/settle/financeAccount',
              'name': 'financeAccount',
              'component': financeAccount
            },
            // 台账汇总
            {
              'path': '/settle/ledgerSummary',
              'name': 'ledgerSummary',
              'component': ledgerSummary,
              'meta': {
                'title': '台账汇总',
                'submitType': 0
              }
            },
            // 财务调账
            {
              'path': '/settle/financeReconciliation',
              'name': 'financeReconciliation',
              'component': financeReconciliation
            },
            // 调账汇总
            {
              'path': '/settle/reconciliationSummary',
              'name': 'reconciliationSummary',
              'component': reconciliationSummary,
              'meta': {
                'title': '调账汇总',
                'submitType': 1
              }
            },
            // 供应商交单管理
            {
              'path': '/settle/supplierDelivery',
              'name': 'supplierDelivery',
              'component': supplierDelivery
            },
            // 结算部交单管理
            {
              'path': '/settle/settlementDelivery',
              'name': 'settlementDelivery',
              'component': settlementDelivery
            },
            // 交单报表
            {
              'path': '/settle/deliveryReport',
              'name': 'deliveryReport',
              'component': deliveryReport
            },
            // 结算进度统计表
            {
              'path': '/settle/settlementAnalysisStatement/settlementProgress',
              'name': 'settlementProgress',
              'component': settlementProgress
            },
            // 收入台账与开票
            {
              'path': '/settle/settlementAnalysisStatement/IncomeStatistics',
              'name': 'IncomeStatistics',
              'component': IncomeStatistics
            },
            // 收入分段统计表
            {
              'path': '/settle/settlementAnalysisStatement/revenueSegmentation',
              'name': 'revenueSegmentation',
              'component': revenueSegmentation
            },
            // 根据收入结算
            {
              'path': '/settle/reconciliation/revenueSettlement',
              'name': 'revenueSettlement',
              'component': revenueSettlement
            },
            // 根据合同
            {
              'path': '/settle/reconciliation/contractSettlement',
              'name': 'contractSettlement',
              'component': contractSettlement
            },
            // 根据交单
            {
              'path': '/settle/reconciliation/tenderDocumentSettlement',
              'name': 'tenderDocumentSettlement',
              'component': tenderDocumentSettlement
            }
          ]
        },
        // 财务管理
        {
          'path': '/financial',
          'name': 'financial',
          'component': financial,
          'children': [
            // 公路价格管理
            {
              'path': '/financial/highway',
              'name': 'highway',
              'component': highway
            },
            // 公路价格管理
            {
              'path': '/financial/other',
              'name': 'other',
              'component': other
            },
            // 劳务价格管理
            {
              'path': '/financial/labor',
              'name': 'labor',
              'component': labor
            },
            // 劳务价格管理
            {
              'path': '/financial/porta',
              'name': 'porta',
              'component': porta
            },
            // 委托商费用管理
            {
              'path': '/financial/entrustprice',
              'name': 'entrustprice',
              'component': entrustprice
            },
            // 港口堆存费价格设置
            {
              'path': '/financial/stockpiledPrice',
              'name': 'stockpiledPrice',
              'component': stockpiledPrice
            },
            // 港口费用管理
            {
              'path': '/financial/port',
              'name': 'port2',
              'component': port2
            },
            // 仓库价格管理
            {
              'path': '/financial/warehouse',
              'name': 'warehouse',
              'component': warehouse2
            },
            // 提车费用管理
            {
              'path': '/financial/mention',
              'name': 'mention',
              'component': mention
            },
            // 水路价格管理
            {
              'path': '/financial/waterway',
              'name': 'waterway',
              'component': waterway
            },
            // 水路价格管理
            {
              'path': '/financial/portWork',
              'name': 'portWork',
              'component': portWork
            },
            // 托运费收款
            {
              'path': '/financial/cars',
              'name': 'car',
              'component': car
            },
            // 港口费收款
            {
              'path': '/financial/ships',
              'name': 'ship2',
              'component': ship2
            },
            // 装卸费管理
            {
              'path': '/financial/handings',
              'name': 'handling',
              'component': handling
            },
            // 线车队支付
            {
              'path': '/financial/carp',
              'name': 'car2',
              'component': car2
            },
            // 财务确认
            {
              'path': '/financial/financialConfirmation',
              'name': 'financialConfirmation',
              'component': financialConfirmation
            },
            // 线船舶支付
            {
              'path': '/financial/shipp',
              'name': 'ship3',
              'component': ship3
            },
            // 收入挂账管理
            {
              'path': '/financial/income2',
              'name': 'income2',
              'component': income2
            },
            // 支出挂账管理
            {
              'path': '/financial/expend',
              'name': 'expend',
              'component': expend
            },
            // 装卸费支付
            {
              'path': '/financial/handingp',
              'name': 'handling2',
              'component': handling2
            },
            // 支出价格设置（供应商） 特殊情况价格设置
            {
              'path': '/financial/supplierSpecialPrice',
              'name': 'supplierSpecialPrice',
              'component': supplierSpecialPrice
            },
            // 支出价格设置 - 年月计划价格设置
            {
              'path': '/financial/monthlyMonthlyPlannedExpenditurePriceSetting',
              'name': 'monthlyMonthlyPlannedExpenditurePriceSetting',
              'component': monthlyMonthlyPlannedExpenditurePriceSetting
            },
            // 支出价格设置（供应商） 特殊情况价格设置
            {
              'path': '/financial/portWarehouseExpenditurePriceSetting',
              'name': 'portWarehouseExpenditurePriceSetting',
              'component': portWarehouseExpenditurePriceSetting
            },
            // 收入价格设置（委托商） 特殊情况价格设置
            {
              'path': '/financial/consignorSpecialPrice',
              'name': 'consignorSpecialPrice',
              'component': consignorSpecialPrice
            },
            // 收入价格设置（委托商） 港口库房价格设置
            {
              'path': '/financial/harborWarehouseIncomePriceSetting',
              'name': 'harborWarehouseIncomePriceSetting',
              'component': harborWarehouseIncomePriceSetting
            },
            {
              'path': '/financial/monthYearPlanRevenuePriceSetting',
              'name': 'monthYearPlanRevenuePriceSetting',
              'component': monthYearPlanRevenuePriceSetting
            },
            // 轮船结算-江运部分-商品车补价
            {
              'path': '/financial/commercialCarPrice',
              'name': 'commercialCarPrice',
              'component': commercialCarPrice
            },
            // 轮船结算-江运部分-对账明细
            {
              'path': '/financial/reconciliationDetails',
              'name': 'reconciliationDetails',
              'component': reconciliationDetails
            },
            // 轮船结算-江运部分-月运量图表分析
            {
              'path': '/financial/mothFreightVolumeReport',
              'name': 'mothFreightVolumeReport',
              'component': mothFreightVolumeReport
            },
            // 轮船结算-江运部分-商品车计划
            {
              'path': '/financial/commercialCarPlan',
              'name': 'commercialCarPlan',
              'component': commercialCarPlan
            },
            // 轮船结算-江运部分-江运大报表
            {
              'path': '/financial/riverTransportationReport',
              'name': 'riverTransportationReport',
              'component': riverTransportationReport
            },
            // 轮船结算-统计部分-年月汇报表
            {
              'path': '/financial/yearAndMonthReport',
              'name': 'yearAndMonthReport',
              'component': yearAndMonthReport
            },
            // 轮船结算-统计部分-年月汇总表
            {
              'path': '/financial/yearAndMonthSummary',
              'name': 'yearAndMonthSummary',
              'component': yearAndMonthSummary
            },
            // 轮船结算-统计部分-多版本数据差异分析-年月计划
            {
              'path': '/financial/dataDifferenceAnalysis/monthlyPlan',
              'name': 'monthlyPlan',
              'component': monthlyPlan
            },
            // 轮船结算-统计部分-多版本数据差异分析-暂估收支
            {
              'path': '/financial/dataDifferenceAnalysis/provisionalIncomeExpenditure',
              'name': 'provisionalIncomeExpenditure',
              'component': provisionalIncomeExpenditure
            },
            // 轮船结算-统计部分-多版本数据差异分析-预结算收支
            {
              'path': '/financial/dataDifferenceAnalysis/preSettlementIncomeExpenditure',
              'name': 'preSettlementIncomeExpenditure',
              'component': preSettlementIncomeExpenditure
            },
            // 轮船结算-统计部分-多版本数据差异分析-库房及其他
            {
              'path': '/financial/dataDifferenceAnalysis/warehouseAndOther',
              'name': 'warehouseAndOther',
              'component': warehouseAndOther
            },
            // 轮船结算-统计部分-营业收支及资产净值
            {
              'path': '/financial/revenueAndExpenditureAndNetValue',
              'name': 'revenueAndExpenditureAndNetValue',
              'component': revenueAndExpenditureAndNetValue
            },
            // 财务报表-收/付款时间报表
            {
              'path': '/financial/statistics',
              'name': 'statistics',
              'component': statistics
            }
          ]
        },
        // 审核管理
        {
          'path': '/audit',
          'name': 'audit',
          'component': audit1,
          'children': [
            // 委托商审核
            {
              'path': '/audit/entrust',
              'name': 'entrust',
              'component': entrust
            },
            // 运输车审核
            {
              'path': '/audit/transportCar',
              'name': 'transportCar',
              'component': transportCar
            },
            // 公路供应商审核
            {
              'path': '/audit/highWay',
              'name': 'highWay',
              'component': highWay
            },
            // 委托商日考审核
            {
              'path': '/audit/day',
              'name': 'day',
              'component': day
            },
            // 委托商月考审核
            {
              'path': '/audit/month',
              'name': 'month',
              'component': month
            },
            // 合同价格审核
            {
              'path': '/audit/price',
              'name': 'price',
              'component': price
            },
            // 合同审核
            {
              'path': '/audit/audit',
              'name': 'audit',
              'component': audit
            },
            // 结算审核
            {
              'path': '/audit/settle',
              'name': 'settle',
              'component': settle1
            },
            // 结算审核
            {
              'path': '/audit/pay',
              'name': 'pay',
              'component': pay
            },

            // 审核人员配置
            // 委托商审核
            {
              'path': '/audit/entrustAudit',
              'name': 'entrustAudit',
              'component': person
            },
            // 公路供应商审核
            {
              'path': '/audit/highWayAudit',
              'name': 'highWayAudit',
              'component': person
            },
            // 运输车审核
            {
              'path': '/audit/transporter',
              'name': 'transporter',
              'component': person
            },
            // 价格评审审核管理
            {
              'path': '/audit/auditPrice',
              'name': 'auditPrice',
              'component': person
            },
            // 供应商日考审核
            {
              'path': '/audit/dailyCheck',
              'name': 'dailyCheck',
              'component': person
            },
            // 供应商月考审核
            {
              'path': '/audit/moonCheck',
              'name': 'moonCheck',
              'component': person
            },
            // 供应商年考审核
            {
              'path': '/audit/yearCheck',
              'name': 'yearCheck',
              'component': person
            },
            // 供应商培训审核
            {
              'path': '/audit/training',
              'name': 'training',
              'component': person
            },
            // 质损审核
            {
              'path': '/audit/qualityLoss',
              'name': 'qualityLoss',
              'component': person
            },
            // 年月计划审核
            // {
            //   'path': '/audit/monthlyPlan',
            //   'name': 'monthlyPlan',
            //   'component': monthlyPerson
            // },
            // 变更审核
            {
              'path': '/audit/changeReview',
              'name': 'changeReview',
              'component': person
            },
            // 其他费用审核
            {
              'path': '/audit/otherCost',
              'name': 'otherCost',
              'component': person
            },
            // 抵扣开票费用审核
            {
              'path': '/audit/deduct',
              'name': 'deduct',
              'component': person
            },
            // 对账单审核
            {
              'path': '/audit/personAccountStatement',
              'name': 'personAccountStatement',
              'component': person
            },
            // 燃油费审核
            {
              'path': '/audit/fuelCostReview',
              'name': 'fuelCostReview',
              'component': person
            },


            // 供应商培训审核
            {
              'path': '/audit/supplierTrain',
              'name': 'supplierTrain',
              'component': supplierTrain
            },
            // 其他费用审核
            {
              'path': '/audit/otherFees',
              'name': 'otherFees',
              'component': otherFees,
              'meta': {
                'title': '其他费用审核'
              }
            },
            // 抵扣开票费用审核
            {
              'path': '/audit/deductCost',
              'name': 'deductCost',
              'component': deductCost,
              'meta': {
                'title': '抵扣开票费用审核'
              }
            },
            // 燃油费审核
            {
              'path': '/audit/fuelCost',
              'name': 'fuelCost',
              'component': fuelCost,
              'meta': {
                'title': '燃油费审核'
              }
            },
            // 对账单审核
            {
              'path': '/audit/accountStatement',
              'name': 'accountStatement',
              'component': accountStatement,
              'meta': {
                'title': '对账单审核'
              }
            },
            // 对账单审核
            {
              'path': '/audit/statementReview',
              'name': 'statementReview',
              'component': statementReview,
              'meta': {
                'title': '对账单复核'
              }
            },
            {
              'path': '/audit/dataModification',
              'name': 'dataModification',
              'component': dataModification,
              'meta': {
                'title': '数据修改审核'
              }
            },
            {
              'path': '/audit/change',
              'name': 'change',
              'component': change,
              'meta': {
                'title': '变更审核'
              }
            },
            // 财务审核-整车结算
            {
              'path': '/audit/vehicleSettlement',
              'name': 'vehicleSettlement',
              'component': vehicleSettlement,
              'meta': {
                'title': '整车结算'
              }
            }
            // 整车物流审核-年月计划审核
            // {
            //   'path': '/audit/monthlyPlanReview',
            //   'name': 'monthlyPlanReview',
            //   'component': monthlyPlanReview
            // }
            // 财务审核-金融监管
            // {
            //     'path': '/audit/financialSupervision',
            //     'name': 'financialSupervision',
            //     'component': financialSupervision,
            //     'meta': {
            //         'title': '金融监管'
            //     }
            // }
          ]
        },
        // 统计报表
        {
          'path': '/statistical',
          'name': 'statistical',
          'component': statistical,
          'children': [
            // 客户订单统计
            {
              'path': '/statistical/income',
              'name': 'income',
              'component': income
            },
            // 车队统计
            {
              'path': '/statistical/expense',
              'name': 'expense',
              'component': expense
            },
            // 船舶统计
            {
              'path': '/statistical/order',
              'name': 'order',
              'component': order
            },
            // 仓库统计
            {
              'path': '/statistical/car',
              'name': 'car3',
              'component': car3
            },
            // 收入报表
            {
              'path': '/statistical/ship',
              'name': 'ship4',
              'component': ship4
            },
            // 支出报表
            {
              'path': '/statistical/warehouse',
              'name': 'warehouse',
              'component': warehouse
            },
            // 运营看板
            {
              'path': '/statistical/operating',
              'name': 'operating',
              'component': operating
            }
          ]
        },
        // 系统设置
        {
          'path': '/system',
          'name': 'system',
          'component': system
        },
        // 个人信息
        {
          'path': '/user',
          'name': 'user',
          'component': user
        },
        // 消息中心
        {
          'path': '/message',
          'name': 'message',
          'component': message
        }
      ]
    }
  ]
});
